import { MachineTechnology, isCogeneration } from '@e2m-customer-portal/shared';
import { ArrowDownIcon } from '../../../assets/icons';

export function setArrowIcon(section: boolean, technologies: readonly MachineTechnology[]) {
  if (isCogeneration(technologies)) {
    return <></>;
  } else {
    return section ? <ArrowDownIcon className="rotate-180" /> : <ArrowDownIcon />;
  }
}
